import {
  BirthDay,
  CreatedBy,
  PremiumIcon,
  ProfileId,
  UserHeight,
} from "assets/icons";
import Tag from "BaseWidgets/tag";
import Button from "components/BaseWidgets/button";
import VerificationBadgeModal from "components/CustomWidgets/verificationBadgeModal";
import React, { useState } from "react";
import "./style.scss";
import GoPremiumCard from "components/CustomWidgets/goPremiumCard";
import { EyeOutlined } from "@ant-design/icons";
import { profileVerification } from "utils/profileVerification";
import { displayTextOrDash, normalizeText } from "utils/formatHelper";
import FemaleEmptyState from "assets/images/png/empty-female.png";
import MaleEmptyState from "assets/images/png/empty-male.png";
import { retrieveToken } from "utils/storage";
import { useNavigate } from "react-router-dom";
import { useProfileCompletion } from "hooks/api/useHome";
import { VERIFICATION_TYPE } from "components/MyProfile/helper";

const ProfileCard = ({
  profilePic,
  userName,
  religion,
  profession,
  livesIn,
  userHeight,
  profileId,
  userAge,
  idVerification,
  isPremium,
  createdBy,
  setManagedPhoto,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const userData = JSON.parse(retrieveToken("user") || "{}");
  const aecId = userData?.aec_id;
  const defaultImage =
    normalizeText(userData?.gender) === "male"
      ? MaleEmptyState
      : FemaleEmptyState;
  const profileImage = profilePic || defaultImage;

  const { data } = useProfileCompletion();

  const verificationType = data?.common_home_data?.verification_type;

  const apiUserName = data?.common_home_data?.name;

  const finalUserName = apiUserName || userName;

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  const infoItems = [
    { icon: <BirthDay />, label: `${displayTextOrDash(userAge)} years` },
    { icon: <ProfileId />, label: `ID: ${displayTextOrDash(profileId)}` },
    { icon: <UserHeight />, label: `${displayTextOrDash(userHeight)}` },
    {
      icon: <CreatedBy />,
      label: `Profile for: ${displayTextOrDash(createdBy)}`,
    },
  ];

  const bioItems = [
    { title: "Religion", value: displayTextOrDash(religion) },
    { title: "Profession", value: displayTextOrDash(profession) },
    { title: "Lives in", value: displayTextOrDash(livesIn) },
  ];

  const [selected, setSelected] = useState(false);
  const navigate = useNavigate();

  let idDescription = "ID verification not completed yet.";
  let physicalDescription = "Physical verification not completed yet.";

  if (
    verificationType === VERIFICATION_TYPE.ID_VERIFIED ||
    verificationType === VERIFICATION_TYPE.BOTH_VERIFIED
  ) {
    idDescription = `We have verified ${finalUserName}’s ID.`;
  }

  if (
    verificationType === VERIFICATION_TYPE.PHYSICAL_VERIFIED ||
    verificationType === VERIFICATION_TYPE.BOTH_VERIFIED
  ) {
    physicalDescription =
      "This profile has been physically verified, ensuring authenticity and trust for a secure matchmaking experience.";
  }

  return (
    <>
      <div className={`user-profile-card my-profile-card`}>
        <div className="profile-image-area">
          <img src={profileImage} alt="profile pic" />
          {isPremium && (
            <div className="profile-premium">
              <PremiumIcon fill="white" stroke="white" />
            </div>
          )}
          <Button
            onClick={() => setManagedPhoto(true)}
            className="upload-btn"
            variant="link"
          >
            Edit and upload
          </Button>
        </div>

        <div className="profile-info">
          <div className="initial-data">
            <h4 className="font-title-normal capitalize">
              {displayTextOrDash(userName)}
            </h4>
            {idVerification > 0 && (
              <span className="verification-badge" onClick={handleOpenModal}>
                {profileVerification(idVerification)}
              </span>
            )}
            {idVerification != 3 && (
              <Button href={"/verification"} variant="link">
                Verify account
              </Button>
            )}
          </div>
          {!isPremium && (
            <Tag
              readOnly
              className="font-body-normal mt-3"
              isActive={selected}
              onClick={() => setSelected(!selected)}
            >
              Free member
            </Tag>
          )}
          <div className="user-stats gap-2">
            {infoItems.map(({ icon, label }, i) => (
              <div key={i} className="base-info">
                {icon}
                <p className="font-body-normal">{label}</p>
              </div>
            ))}
          </div>

          <div className="user-bio">
            {bioItems.map(({ title, value }, i) => (
              <div key={i} className="user-card">
                <h3 className="font-body-normal grey-shade">{title}</h3>
                <p className="font-body-lg">{displayTextOrDash(value)}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-2 mt-4">
            <h3 className="font-body-normal grey-shade">
              How your profile looks to others
            </h3>
            <Button
              className="gap-1 profile-preview-btn"
              icon={<EyeOutlined />}
              variant="link"
              onClick={() => {
                if (aecId) {
                  navigate(`/person-profile/preview`, {
                    state: { preview: true },
                  });
                }
              }}
            >
              Profile preview
            </Button>
          </div>
        </div>
        {!isPremium && (
          <GoPremiumCard
            premiumIcon
            title="Upgrade to premium & connect without limits!"
            buttonText="Upgrade plan"
            className="profile-premium-card"
          />
        )}
      </div>
      <VerificationBadgeModal
        open={openModal}
        onCancel={handleCancel}
        idDescription={idDescription}
        physicalDescription={physicalDescription}
      />
    </>
  );
};

export default ProfileCard;
